import { render } from "./layout.vue?vue&type=template&id=7d1ccd8a&scoped=true&ts=true"
import script from "./layout.vue?vue&type=script&lang=ts"
export * from "./layout.vue?vue&type=script&lang=ts"

import "./layout.vue?vue&type=style&index=0&id=7d1ccd8a&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d1ccd8a"]])

export default __exports__